var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadshotPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 417 417",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 208.333,
    cy: 208.333,
    r: 206.832,
    style: {
      fill: "#e3e3e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.368,352.678c0.148,-0.147 0.59,-0.458 0.787,-0.72c0.196,-0.262 1.529,-2.321 1.529,-2.321l9.539,-32.576c0,0 10.473,-55.271 52.945,-55.271c42.471,-0 34.326,-5.818 34.326,-5.818c0,-0 -36.072,-22.109 -29.672,-80.29c6.4,-58.18 47.708,-70.98 68.071,-70.98",
    style: {
      fill: "none",
      stroke: "#000",
      strokeOpacity: 0.5,
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.368,352.678l-4.906,4.907",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "4.17px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.837,358.128c-0,0 -5.303,-5.302 -5.45,-5.45c-0.147,-0.147 -0.59,-0.458 -0.786,-0.72c-0.197,-0.262 -1.53,-2.321 -1.53,-2.321l-9.539,-32.576c0,0 -10.472,-55.271 -52.944,-55.271c-42.472,-0 -34.327,-5.818 -34.327,-5.818c0,-0 36.072,-22.109 29.672,-80.29c-6.399,-58.18 -47.708,-70.98 -68.071,-70.98",
    style: {
      fill: "none",
      stroke: "#000",
      strokeOpacity: 0.5,
      strokeWidth: "8.33px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadshotPlaceholder);
export default __webpack_public_path__ + "static/media/headshot-placeholder.33285227fc5c346ae8bfcec9b61cff0c.svg";
export { ForwardRef as ReactComponent };